import { ProjectActionType, IProjectState, ProjectAction } from "../types/projectDataRanks"

const initialState: IProjectState = {
  projectDataRanks: [],
  loading: false,
  error: null,
}

export const projectDataReducer = (
  state: IProjectState = initialState,
  action: ProjectAction
): IProjectState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECT_DATA_RANKS:
      return { ...state, loading: true }
    case ProjectActionType.FETCH_PROJECT_DATA_RANKS_SUCCESS:
      return { ...state, projectDataRanks: action.payload, loading: false }
    case ProjectActionType.FETCH_PROJECT_DATA_RANKS_ERROR:
      return { ...state, error: action.payload, loading: false }
    default:
      const exhaustiveCheck: never = action
      return state
  }
}

export default projectDataReducer
